import { useEffect, useState, useContext, useCallback } from "react";
import { TokenContext } from "../Main.js";

import { formatDateToString } from "../../functions/helper.js";
import { exportXlsx } from "../../functions/fileHandler.js";
import { months } from "../../functions/helper.js";

import Loader from "../Loader.js";
import { sendRequest } from "../../rest/requests.js";


// -- statistic-component inside Kursteilnahme
const StatisticForm = ({ selectedCourse, id = 0 }) => {

    // access-token
    const [tokenObject, setTokenObject] = useContext(TokenContext);

    // -- states
    const [statistic, setStatistic] = useState();
    const [initialized, setInitialized] = useState(false);
    const [relations, setRelations] = useState();


    // Die Funktion wird VOR dem useEffect definiert und mit useCallback umschlossen.
    const onCourseUpdate = useCallback(async () => {
        setInitialized(false);

        if (selectedCourse) {
            // GET TEILNEHMER OF THIS COURSE FROM DB
            const response = await sendRequest(tokenObject, setTokenObject, 'POST', '/kursteilnahme/kursTeilnehmer', 'Lade Teilnehmer', 'Teilnehmer geladen', { KursKey: selectedCourse });

            // success
            if (response.success) setRelations(response.data);
        }
    }, [selectedCourse, tokenObject, setTokenObject]);


    // -- on course update
    // Der Effekt wird nun nur ausgeführt, wenn sich die stabile `onCourseUpdate`-Funktion ändert.
    useEffect(() => {
        onCourseUpdate();
    }, [onCourseUpdate]);


    // -- create statistic object which gets displayed as a table
    const createStatistic = useCallback(() => {
        const copy = [...relations];

        // sort relations by Teilnahmedatum
        const sorted = copy.sort((a, b) => (new Date(a.Teilnahmedatum) - new Date(b.Teilnahmedatum)));

        const statistic = {};

        // -- run through sorted relations
        for (let i = 0; i < sorted.length; i++) {
            const relation = sorted[i];

            // kind of participation
            const teilnahmeKind = (relation.AD_Email) ? "QR-Code" : (relation.Antwortbogen ? "Antwortbogen" : "Online");

            // date
            const date = new Date(relation.Teilnahmedatum);
            const year = date.getFullYear();
            const monthInteger = date.getMonth();
            var month = months[monthInteger];

            if (!statistic[year]) {
                const obj = { "QR-Code": 0, Online: 0, Antwortbogen: 0 };
                for (let j = 0; j < 12; j++) {
                    obj[months[j]] = { "QR-Code": 0, Online: 0, Antwortbogen: 0 };
                }
                statistic[year] = obj;
            }
            statistic[year][month][teilnahmeKind]++;
            statistic[year][teilnahmeKind]++;
        }
        setStatistic(statistic);
    }, [relations]);


    // -- on relations update
    useEffect(() => {
        if (relations && selectedCourse) {
            createStatistic();
            setInitialized(true);
        }
    }, [relations, selectedCourse, createStatistic])


    // -- export statistic for one specific course
    const exportSingleCourseStatistic = (relations) => {

        // result
        const content = [];

        // run through kurs-teiln-relations from this course
        for (let i = 0; i < relations.length; i++) {
            const thisRelation = relations[i];

            // correct course answers
            const correctAnswers = thisRelation.CorrectAnswerKey ? thisRelation.CorrectAnswerKey : "";
            // answers the user gave
            const userAnswers = thisRelation.AnswerKey ? thisRelation.AnswerKey : "";

            // count how many answers are incorrect
            let incorrectCount = 0;
            for (let j = 0; j < correctAnswers.length; j++) {
                if (correctAnswers[j] !== userAnswers[j]) incorrectCount++;
            }

            console.log(`thisRelation ${JSON.stringify(thisRelation)}`);
            // define one excel row
            content.push({
                VNR: thisRelation.VNR,
                EFN: thisRelation.EFN,
                Titel: thisRelation.Titel,
                Vorname: thisRelation.Vorname,
                Nachname: thisRelation.Nachname,
                Strasse: thisRelation.Strasse,
                Postleitzahl: thisRelation.Postleitzahl,
                Stadt: thisRelation.Stadt,
                Land: thisRelation.Land,
                Mail: thisRelation.Mail,
                Ambulant: thisRelation.Ambulant === 1 ? '✅' : '🚫',
                Stationaer: thisRelation.Stationaer === 1 ? '✅' : '🚫',
                Andere: thisRelation.Andere === 1 ? '✅' : '🚫',
                Fachgebiet: thisRelation.Fachgebiet,
                Teilnahmedatum: formatDateToString(thisRelation.Teilnahmedatum),
                Teilnahmeart: thisRelation.AD_Email ? 'QR-Code' : (thisRelation.Antwortbogen ? 'Antwortbogen' : 'Online'),
                AD_Email: thisRelation.AD_Email,

                Antwortschlüssel: correctAnswers,

                'Frage 1': userAnswers[0],
                'Frage 2': userAnswers[1],
                'Frage 3': userAnswers[2],
                'Frage 4': userAnswers[3],
                'Frage 5': userAnswers[4],
                'Frage 6': userAnswers[5],
                'Frage 7': userAnswers[6],
                'Frage 8': userAnswers[7],
                'Frage 9': userAnswers[8],
                'Frage 10': userAnswers[9],

                Auswertung: userAnswers.length === 10 ? `${10 - incorrectCount} von 10 richtig` : 'Keine Antworten abgegeben'
            });
        }

        // download xlsx-file
        exportXlsx(content, `statistik_kurs_${relations[0].VNR}`);
    }



    if (initialized && relations && statistic) {
        return (
            <div id={`statistic-container-table-${id}`} className='statistic-container-table'>

                <h2>Statistik {selectedCourse}</h2>

                {/* statistic table */}
                {Object.keys(statistic).map((year, i) =>
                    <div key={`statistic-map-year-${i}`} className='table-container'>

                        <table>

                            {/* head */}
                            <thead>
                                <tr>
                                    <th>{year}</th>
                                    {Object.keys(statistic[year]).map((month, i) =>
                                        <th key={`thead-key-${i}`}>{month}</th>
                                    )}
                                </tr>
                            </thead>

                            {/* body */}
                            <tbody>
                                {/* map kind of QR-Code */}
                                <tr>
                                    <td>QR-Code</td>
                                    {Object.keys(statistic[year]).map((month, i) =>
                                        <td key={`tbody-0-key-${i}`}>{statistic[year][month]["QR-Code"] ? <div>{statistic[year][month]["QR-Code"]}</div> : <></>}</td>
                                    )}
                                </tr>
                                {/* map kind of Antwortbogen */}
                                <tr>
                                    <td>Antwortbogen</td>
                                    {Object.keys(statistic[year]).map((month, i) =>
                                        <td key={`tbody-1-key-${i}`}>{statistic[year][month].Antwortbogen ? <div>{statistic[year][month].Antwortbogen}</div> : <></>}</td>
                                    )}
                                </tr>
                                {/* map kind of Online */}
                                <tr>
                                    <td>Online</td>
                                    {Object.keys(statistic[year]).map((month, i) =>
                                        <td key={`tbody-2-key-${i}`}>{statistic[year][month].Online ? <div>{statistic[year][month].Online}</div> : <></>}</td>
                                    )}
                                </tr>
                            </tbody>
                        </table>

                    </div>
                )}

                {/* export button */}
                <div className="basic-btn" onClick={() => exportSingleCourseStatistic(relations)}>Exportiere Kursstatistik {selectedCourse}</div>
            </div>

        )
    }
    else {
        return <Loader />
    }
}

export default StatisticForm